// {{WORKTREE_ROOT}}/picosponsorconsole/app/utils/prefs.ts
// PLAN2 WP10 — first-party preference cookies (no personal data; not HttpOnly because the browser writes some of them).
// The server reads them for the first paint; signed-in users' lang/theme/textMode also live on the profile (mePatch).
export const PREF_COOKIES = { lang: "ps_lang", theme: "ps_theme", text: "ps_text", terms: "ps_terms", rail: "ps_rail", nav: "ps_nav", panel: "ps_panel", region: "ps_region", captureMode: "ps_capture_mode" } as const; // ── WP20 ──
export type Theme = "system" | "light" | "dark";
export type TextMode = "standard" | "dyslexia";
export type TermsMode = "plain" | "terms";
export interface Prefs { lang: string | null; theme: Theme; textMode: TextMode; terms: TermsMode; railOpen: boolean; /** PLAN11 D11-1: the rail the person chose ("auto" = by width). */ navState: "auto" | "open" | "collapsed"; /** PLAN11 D11-2 */ panelState: "open" | "wide" | "closed"; regionChoice: "us" | "eu" | null; /** ── WP20 ── (D20-21) the capture PWA's day or night colours. */ captureMode: "day" | "night" }

export function cookieValue(header: string | null | undefined, name: string): string | null {
  const m = new RegExp(`(?:^|;\\s*)${name}=([^;]*)`).exec(header ?? "");
  return m ? decodeURIComponent(m[1]) : null;
}

export function readPrefs(header: string | null | undefined): Prefs {
  const theme = cookieValue(header, PREF_COOKIES.theme);
  const text = cookieValue(header, PREF_COOKIES.text);
  const terms = cookieValue(header, PREF_COOKIES.terms);
  const lang = cookieValue(header, PREF_COOKIES.lang);
  const region = cookieValue(header, PREF_COOKIES.region);
  return {
    lang: lang && /^[a-z]{2}-[A-Z]{2}$/.test(lang) ? lang : null,
    theme: theme === "light" || theme === "system" ? theme : "dark", // PLAN11 D11-24: no cookie = black
    textMode: text === "dyslexia" ? "dyslexia" : "standard",
    terms: terms === "terms" ? "terms" : "plain",
    railOpen: cookieValue(header, PREF_COOKIES.rail) !== "0",
    navState: cookieValue(header, PREF_COOKIES.nav) === "open" ? "open" : cookieValue(header, PREF_COOKIES.nav) === "collapsed" ? "collapsed" : "auto",
    panelState: cookieValue(header, PREF_COOKIES.panel) === "wide" ? "wide" : cookieValue(header, PREF_COOKIES.panel) === "closed" ? "closed" : "open",
    regionChoice: region === "us" || region === "eu" ? region : null,
    captureMode: cookieValue(header, PREF_COOKIES.captureMode) === "night" ? "night" : "day", // ── WP20 ──
  };
}

export function prefCookieString(name: string, value: string, secure: boolean): string {
  return `${name}=${encodeURIComponent(value)}; Path=/; Max-Age=31536000; SameSite=Lax${secure ? "; Secure" : ""}`;
}
